/**
 * Utility functions for date and time formatting
 */

/**
 * Format event start time for display in event cards
 * @param startsAt - Event start time as ISO string
 * @param endsAt - Event end time as ISO string (optional)
 * @returns Formatted string like "Today, 7pm", "Tomorrow, 3pm", "Nov 10, 7pm", or "LIVE NOW"
 */
export function formatEventTime(
  startsAt: string,
  endsAt?: string | null,
): string {
  const now = new Date();
  const startDate = new Date(startsAt);

  // Check if event is currently live (started but not ended)
  if (startDate <= now) {
    if (endsAt) {
      const endDate = new Date(endsAt);
      if (endDate > now) {
        return 'LIVE NOW';
      }
      // Event has ended
      return 'Ended';
    }
    // No end date, assume still live if started
    return 'LIVE NOW';
  }

  // Format the time portion
  const timeStr = startDate.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: startDate.getMinutes() > 0 ? '2-digit' : undefined,
  });

  // Check if it's today
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventDay = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  );

  const dayDiff = Math.floor(
    (eventDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
  );

  if (dayDiff === 0) {
    return `Today, ${timeStr}`;
  } else if (dayDiff === 1) {
    return `Tomorrow, ${timeStr}`;
  } else {
    // Format as "Nov 10, 7pm"
    const dateStr = startDate.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
    });
    return `${dateStr}, ${timeStr}`;
  }
}
